/** @jsxRuntime classic */
/** @jsx jsx */
import { ArrowDropDownIcon } from '@circleci/compass';
import { theme } from '@circleci/compass/dist/theme';
// oxlint-disable-next-line no-unused-vars
import { jsx } from '@emotion/core';
import { FormattedMessage } from 'react-intl';

import useOpenClose from '~/hooks/useOpenClose';
import { styled } from '~/styled';

export const NavContainer = styled.div`
  padding: 18px 15px 18px 15px;
  margin: 0px -15px 0px -15px;
  background-color: ${theme.colors.n40};
  display: flex;
  flex-direction: column;
`;

export const SectionList = styled.ul`
  margin-bottom: 0px;
  padding-inline-start: 0px;
  list-style: none;
  overflow-y: auto;
  li:last-of-type {
    margin-bottom: 0px;
  }
`;

export const SectionHeading = styled.a`
  color: ${theme.colors.n700};
  &:visited {
    color: ${theme.colors.n700};
  }
  font-size: ${theme.fontSizes.fontsize16};
  font-weight: ${theme.fontWeights.bold};
  letter-spacing: 0.1px;
  line-height: ${theme.space.space24};
  text-decoration: none;
  margin-bottom: ${theme.space.space8};
  margin-top: 0px;
  display: block;
`;

export const SubSectionList = styled.ul`
  margin-bottom: ${theme.space.space12};
  list-style: none;
  padding-left: 0px;
`;

export const SubSectionItem = styled.li`
  line-height: ${theme.space.space24};
`;

export const SubSectionLink = styled.a`
  color: ${theme.colors.n400};
  text-decoration: none;
  display: block;
`;

export const SectionItem = styled.li`
  margin-bottom: ${theme.space.space20};
`;

export const SectionsToggle = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: ${theme.fontWeights.bold};
`;

export const IconContainer = styled.div`
  padding-right: ${theme.space.space12};
`;

const MobileSectionsNavContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { isOpen, toggle } = useOpenClose({ initialState: false });
  return (
    <NavContainer>
      <SectionsToggle onClick={toggle}>
        <FormattedMessage id="shared.MobileSectionsNavContainer.sections" />
        <IconContainer>
          <ArrowDropDownIcon size={16} />
        </IconContainer>
      </SectionsToggle>
      {isOpen && <SectionList>{children}</SectionList>}
    </NavContainer>
  );
};

export default MobileSectionsNavContainer;
